var React = require('react');

function Columns (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#737680","d":"M4.25 10h-2.5c-.276 0-.5-.224-.5-.5V1.75c0-.276.224-.5.5-.5h2.5c.276 0 .5.224.5.5V9.5c0 .276-.224.5-.5.5zm3-.5V1.75c0-.276.224-.5.5-.5h2.5c.276 0 .5.224.5.5V9.5c0 .276-.224.5-.5.5h-2.5c-.276 0-.5-.224-.5-.5z"}));
}

Columns.defaultProps = {"width":"12","height":"12","fill":"none","viewBox":"0 0 12 12"};

module.exports = Columns;

Columns.default = Columns;
